import { AppearancePendingChanges } from "./appearance-editor/appearance-pending-changes.service";
import * as i0 from "@angular/core";
import * as i1 from "./appearance-editor/appearance-pending-changes.service";
var CanDeactivateAppearance = /** @class */ (function () {
    function CanDeactivateAppearance(changes) {
        this.changes = changes;
    }
    CanDeactivateAppearance.prototype.canDeactivate = function () {
        return this.changes.canDeactivate();
    };
    CanDeactivateAppearance.ngInjectableDef = i0.defineInjectable({ factory: function CanDeactivateAppearance_Factory() { return new CanDeactivateAppearance(i0.inject(i1.AppearancePendingChanges)); }, token: CanDeactivateAppearance, providedIn: "root" });
    return CanDeactivateAppearance;
}());
export { CanDeactivateAppearance };
